import { Unauthorized } from '@/app/errors/Entitlement.errors'

/**
 * Generate error message from axios catch
 * @param {AxiosError} error
 */
export const apiErrorHandler = (error, { entitlementName, actionName } = {}) => {
  console.error(error)
  let message = 'Network Error'
  let status = null

  if (error) {
    if (error instanceof Unauthorized) {
      return { message: error.toString(), status: 403 }
    } else if (error.response) {
      if (error.response.status === 403) {
        const unauthorized = new Unauthorized({ entitlementName, actionName })
        return { message: unauthorized.toString(), status: 403 }
      } else if ('status_message' in error.response.data) {
        message = error.response.data.status_message
      }

      status = error.response.status
    }
  }

  return { message, status }
}
